import gsap from '../lib/gsap.min';
import ScrollTrigger from '../lib/ScrollTrigger.min';

export function mosaicTopFunc() {
	const mosaicParts = document.querySelectorAll('.mosaic_parts');
	if (!mosaicParts.length) return;

	const COLOR = '#4266c9';

	mosaicParts.forEach(part => {
    const isLast = part.classList.contains('last');
		const canvas = part.querySelector('.mosaic_canvas');
		if (!canvas) return;

		const ctx = canvas.getContext('2d');
		if (!ctx) return;

		const offscreenCanvas0 = document.createElement('canvas');
		const offctx0 = offscreenCanvas0.getContext('2d');

		let tile_count, dpr, baseWidth, baseHeight, offscreenWidth, COLS;
		let TILE, HALF, CUTOUT_RADIUS, CIRCLE_RADIUS, moveDistance, PAD_Y, TOP_ROW_Y, BOTTOM_ROW_Y;

		const drawBoxShape = (ctx, x, y) => {
			const prevComposite = ctx.globalCompositeOperation;
			ctx.beginPath();
			ctx.rect(x, y, TILE, TILE);
			ctx.fill();

			ctx.globalCompositeOperation = 'destination-out';
			ctx.beginPath();
			ctx.arc(x + HALF, y + HALF, CUTOUT_RADIUS, 0, Math.PI * 2);
			ctx.fill();
			ctx.globalCompositeOperation = prevComposite;
		};

		const drawCircleShape = (ctx, x, y, ox, oy) => {
			ctx.beginPath();
			ctx.arc(x + ox, y + HALF + oy, CIRCLE_RADIUS, 0, Math.PI * 2);
			ctx.fill();
		};

		const setup = () => {
      tile_count = window.innerWidth <= 767 ? 8 : 12;
			dpr          = window.devicePixelRatio || 1;
			baseWidth    = document.documentElement.clientWidth;
			TILE         = Math.round(baseWidth / tile_count / 2) * 2;
			HALF         = TILE / 2;
			CUTOUT_RADIUS = HALF;
			CIRCLE_RADIUS = HALF + 0.2;
			moveDistance = TILE;
			PAD_Y        = isLast ? 0 : moveDistance*2;
			TOP_ROW_Y    = PAD_Y;
			BOTTOM_ROW_Y = PAD_Y + TILE;
			baseHeight   = TILE * 2 + moveDistance * 2;
			offscreenWidth = baseWidth + TILE;
			COLS         = Math.ceil(offscreenWidth / (TILE * 2)) + 1;

			canvas.width = Math.round(baseWidth * dpr);
			canvas.height = Math.round(baseHeight * dpr);
			ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

			offscreenCanvas0.width = Math.round(offscreenWidth * dpr);
			offscreenCanvas0.height = Math.round(baseHeight * dpr);
			offctx0.setTransform(dpr, 0, 0, dpr, 0, 0);

		};

		const render = (progress = 0, circleStates = null, rowProgress = 1) => {
			const startOffsetX = -HALF;
			const ACTIVE_COLS = COLS;
			const hasProgress = circleStates
				? circleStates.some(state => state.progress > 0)
				: progress > 0;
			// 通常は上段が下段の位置から本来の位置へスライドし、.lastは逆に下段が上段の位置から本来の位置へスライドする
			const currentTopY = isLast
				? TOP_ROW_Y
				: BOTTOM_ROW_Y - (BOTTOM_ROW_Y - TOP_ROW_Y) * rowProgress;
			const currentBottomY = isLast
				? TOP_ROW_Y + (BOTTOM_ROW_Y - TOP_ROW_Y) * rowProgress
				: BOTTOM_ROW_Y;

			const renderSet = (context, offset, layerIndex = 0) => {
				context.clearRect(0, 0, offscreenWidth, baseHeight);
				context.fillStyle = COLOR;
				context.globalCompositeOperation = 'source-over';

				const addXorQuadrantRects = () => {
					for (let col = 0; col < ACTIVE_COLS; col += 1) {
						context.rect(col * TILE * 2 + offset + HALF, currentTopY, HALF, HALF);
						context.rect(col * TILE * 2 + offset + HALF, currentBottomY + HALF, HALF, HALF);
					}
				};

				const drawAllCircles = () => {
					for (let col = 0; col < ACTIVE_COLS; col += 1) {
						const stateBase = layerIndex * ACTIVE_COLS * 2 + col * 2;
						const topProgress = circleStates ? (circleStates[stateBase]?.progress ?? 0) : progress;
						const bottomProgress = circleStates ? (circleStates[stateBase + 1]?.progress ?? 0) : progress;
						const boxTopOffsetX = col * TILE * 2 + offset + moveDistance*0.5 * topProgress;
						const boxBottomOffsetX = col * TILE * 2 + offset + TILE + moveDistance*0.5 * bottomProgress;
						const circle1Offset = {
							x: startOffsetX - moveDistance*0.5 * topProgress,
							y: 0,
						};
						const circle2Offset = {
							x: startOffsetX - moveDistance*0.5 * bottomProgress,
							y: 0,
						};
						drawBoxShape(context, boxTopOffsetX, currentTopY);
						drawBoxShape(context, boxBottomOffsetX, currentBottomY);
						drawCircleShape(context, col * TILE * 2 + offset + TILE, currentTopY, circle1Offset.x, circle1Offset.y);
						drawCircleShape(context, col * TILE * 2 + offset + TILE + TILE, currentBottomY, circle2Offset.x, circle2Offset.y);
					}
				};

				context.save();
				context.beginPath();
				addXorQuadrantRects();
				context.clip();
				context.globalCompositeOperation = hasProgress ? 'xor' : 'source-over';
				drawAllCircles();
				context.restore();

				context.save();
				context.beginPath();
				context.rect(0, 0, offscreenWidth, baseHeight);
				addXorQuadrantRects();
				context.clip('evenodd');
				context.globalCompositeOperation = 'source-over';
				drawAllCircles();
				context.restore();
			};

			ctx.clearRect(0, 0, baseWidth, baseHeight);
			ctx.globalCompositeOperation = 'source-over';

			renderSet(offctx0, 0, 0);

			ctx.drawImage(offscreenCanvas0, 0, 0, Math.round((baseWidth + HALF) * dpr), Math.round(baseHeight * dpr), -HALF,       0, baseWidth + HALF, baseHeight);
		};

		setup();
		render(0, null, 0);
		let hasPlayed = false;
		let playTween = null;
 
		ScrollTrigger.create({
			trigger: part,
			start: 'bottom bottom',
			// once: true,
			invalidateOnRefresh: true,
			onEnter: () => {
				if (hasPlayed) return;
				hasPlayed = true;
				if (playTween) playTween.kill();
				const activeCols = COLS;
				const circleStates = Array.from({ length: activeCols * 2 }, () => ({ progress: 0 }));
				const rowState = { progress: 0 };

				playTween = gsap.timeline();
				playTween.to(rowState, {
					progress: 1,
					duration: 0.6,
					ease: 'power2.out',
					onUpdate: () => render(0, circleStates, rowState.progress),
				});
				playTween.to(circleStates, {
					progress: 1,
					duration: 1.4,
					stagger: {
						each: 0.04,
						from: 'random',
					},
					ease: 'power2.inOut',
					onUpdate: () => render(0, circleStates, rowState.progress),
					onComplete: () => render(1, null, 1),
				});
			},
			onRefresh: () => {
				setup();
				render(hasPlayed ? 1 : 0, null, hasPlayed ? 1 : 0);
			},
		});
	});
}
